import { APIResponse } from 'tools/types';
import { instance } from 'api/api';

export const workflowAPI = {
    async getSettings(workflowId: number): Promise<any> {
        const url = `/data/workflow/${workflowId}/settings`;
        const response = await instance.get<APIResponse<any>>(url, {});
        return response.data.data;
    },
    async updateSettings(workflowId: number, data: any): Promise<any> {
        const url = `/data/workflow/${workflowId}/settings`;
        const response = await instance.post<APIResponse<any>>(url, data);
        return response.data.data;
    },
    async getItemSettings(workflowId: number, selectedItem: string): Promise<any> {
        const url = `/data/workflow/${workflowId}/item/${selectedItem}/settings`;
        const response = await instance.get<APIResponse<any>>(url, {});
        return response.data.data;
    },
    async getAllItemSettings(workflowId: number): Promise<any> {
        const url = `/data/workflow/${workflowId}/get-all-item-settings`;
        const response = await instance.get<APIResponse<any>>(url, {});
        return response.data.data;
    },
    async updateItemSettings(workflowId: number, selectedItem: string, data: any): Promise<any> {
        const url = `/data/workflow/${workflowId}/item/${selectedItem}/settings`;
        const response = await instance.post<APIResponse<any>>(url, data);
        return response.data.data;
    },
    async deleteItem(workflowId: number, selectedItem: string): Promise<any> {
        const url = `/data/workflow/${workflowId}/item/${selectedItem}/delete`;
        const response = await instance.delete<APIResponse<any>>(url);
        return response.data.data;
    },
    async updateAllItemSettings(workflowId: number, data: any): Promise<any> {
        const url = `/data/workflow/${workflowId}/update-all-item-settings`;
        const response = await instance.post<APIResponse<any>>(url, data);
        return response.data.data;
    },
    async getCurrentRun(workflowId: number): Promise<any> {
        const url = `/data/workflow/${workflowId}/current-run`;
        const response = await instance.get<APIResponse<any>>(url, {});
        return response.data.data;
    },
    async runItem(workflowId: number, runId: number, selectedItem: string, data: any): Promise<any> {
        const url = `/data/workflow/${workflowId}/item/${selectedItem}/run-item?run_id=${runId}`;
        const response = await instance.post<APIResponse<any>>(url, data);
        return response.data.data;
    },
    async closeCurrentRun(workflowId: number, runId: number): Promise<any> {
        const url = `/data/workflow/${workflowId}/close-run?run_id=${runId}`;
        const response = await instance.post<APIResponse<any>>(url, {});
        return response.data.data;
    },
};
